import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { TDashboardKRA } from "../models/dashboard";
import { throwApiError } from "./apiError";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

/**
 * GET API call using Axios
 */

export const getDashboardKRA = async (params: any): Promise<TDashboardKRA> => {
  try {
    let headers = getTrackingHeadersMap(ApiType.DASHBOARD_KRA);
    const response = await axios.post(getUrl(ApiType.DASHBOARD_KRA), params, { headers });
    return response?.data;
  } catch (error) {
    return throwApiError(error, ErrorMessages.dashboardSummaryAPIError, { badRequestOrder: "errorsFirst" });
  }
};
